import DonationService from "../../service/DonationService";

export const namespaced = true;
//compare
let compare = (a, b) => {
  if (new Date(a.datecreated) < new Date(b.datecreated)) return 1;
  if (new Date(a.datecreated) > new Date(b.datecreated)) return -1;
  return 0;
};

export const state = {
  donationStats: {
    totalDonationAmount: "0",
    totalNumberOfDonations: "0",
    totalNumberOfOrganizations: "0"
  },
  donations: [],
  walletAccountNumber: "",
  walletAccountName: ""
};

export const getters = {
  getWalletAccountNumber(state) {
    return state.walletAccountNumber;
  },
  getOrganisationsMini(state) {
    return state.organizationsMini;
  }
};

export const mutations = {
  SET_DONATION_STATS(state, payload) {
    state.donationStats = payload;
  },
  SET_DONATIONS(state, payload) {
    state.donations = payload.sort(compare);
  },
  ADD_DONATIONS(state, payload) {
    state.donations.push(payload);
  },
  SET_WALLET_ACCOUNT_NUMBER(state, payload) {
    state.walletAccountNumber = payload;
  },
  SET_WALLET_ACCOUNT_NAME(state, payload) {
    state.walletAccountName = payload;
  }
};
export const actions = {
  getDonationsStats({ commit, dispatch }, payload) {
    return DonationService.getDonationsStats(payload)
      .then(response => {
        let responseData = response.data;
        if (responseData.responsecode === "00") {
          commit("SET_DONATION_STATS", {
            totalDonationAmount: responseData.totalDonationAmount,
            totalNumberOfDonations: responseData.totalNumberOfDonations,
            totalNumberOfOrganizations: responseData.totalNumberOfOrganizations
          });
        }
      })
      .catch(error => {
        let notification = {
          type: "error",
          message: `Error -> ${error}`
        };
        dispatch("notification/add", notification, { root: true });
        throw error;
      });
  },
  getAllDonations({ commit, dispatch }, payload) {
    dispatch("loader/showTableLoader", true, { root: true });
    return DonationService.getAllDonations(payload)
      .then(response => {
        dispatch("loader/showTableLoader", false, { root: true });

        let responseData = response.data;

        if (responseData.responsecode === "00") {
          commit("SET_DONATIONS", responseData.donations);
        }
      })
      .catch(error => {
        dispatch("loader/showTableLoader", false, { root: true });

        let notification = {
          type: "error",
          message: `Error -> ${error}`
        };
        dispatch("notification/add", notification, { root: true });
        throw error;
      });
  },
  createDonationWallet({ commit, dispatch }, payload) {
    return DonationService.createDonationWallet(payload).then(response => {
      let responseData = response.data;

      if (responseData.responsecode === "00") {
        commit("SET_WALLET_ACCOUNT_NUMBER", responseData.walletAccountNumber);
        commit("SET_WALLET_ACCOUNT_NAME", responseData.accountName);
        // dispatch("sh/")
        let notification = {
          type: `success`,
          message: `Donation Wallet Created Successfully`
        };
        dispatch("notification/add", notification, { root: true });
      }

      return responseData;
    });
  }
};
